import * as React from 'react'
import { Text } from '@chakra-ui/core'

const Copyright = (props: any) => (
  <Text {...props}>Copyright © 2012 - {new Date().getFullYear()} SovTech</Text>
)

export default Copyright
